import { Outlet } from "react-router-dom";

const SportListingMain = (props: any) => {

    return (
        <>
            <Outlet />
        </>
    );
}

export default SportListingMain;